import { readAccessToken } from '@/utils/access-token';

// Who the attached bearer belongs to. `merchant` is a Shopify merchant holding a
// DoughDog-issued access token — its `Me.source` is `shopify`, so deliberately
// not reusing that value here would collide; this names the *token holder*.
export type AuthIdentity = 'kinde' | 'merchant' | 'none';

interface KindeTokenSource {
	isAuthenticated: boolean | null;
	getToken: () => string | null;
}

// Single source of truth for bearer precedence, shared by AuthProvider (bootstrap)
// and useAuthenticatedFetch (per-request): a Kinde team-member token wins, else
// the merchant access token from sessionStorage, else nothing.
export const resolveBearer = async (
	kinde: KindeTokenSource,
): Promise<{ token: string | null; identity: AuthIdentity }> => {
	if (kinde.isAuthenticated) {
		try {
			const token = await kinde.getToken();

			if (typeof token === 'string' && token) {
				return { identity: 'kinde', token };
			}
		} catch {
			// Kinde token unavailable; fall through to the merchant access token.
		}
	}

	const merchantToken = readAccessToken();

	if (merchantToken) {
		return { identity: 'merchant', token: merchantToken };
	}

	return { identity: 'none', token: null };
};
